module.exports = __webpack_public_path__ + "static/media/tissue_growth_simulation.52ba191c.gif";